import { render, staticRenderFns } from "./OtherIncomeHead.vue?vue&type=template&id=5a66e1f8&scoped=true"
import script from "./OtherIncomeHead.vue?vue&type=script&lang=js"
export * from "./OtherIncomeHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a66e1f8",
  null
  
)

export default component.exports